import React, { Component } from 'react';
import { WHATSAPP_URL } from './config';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  className?: string;
  href?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  href,
  onClick,
  icon
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-semibold transition-all duration-300 ease-out';
  const variants = {
    primary: 'bg-nova-cyan text-nova-dark hover:bg-nova-cyanHover hover:shadow-[0_0_20px_rgba(0,212,255,0.4)] hover:-translate-y-1',
    secondary: 'bg-nova-dark text-white hover:bg-black hover:shadow-xl hover:-translate-y-1',
    outline: 'bg-transparent border-2 border-nova-gray/20 text-nova-dark hover:border-nova-cyan hover:text-nova-cyan',
    ghost: 'bg-white/50 backdrop-blur-md border border-white/60 text-nova-dark hover:bg-white/80 hover:shadow-glass-hover'
  };
  const Component = href ? 'a' : 'button';
  const target = href === WHATSAPP_URL ? '_blank' : undefined;
  const rel = href === WHATSAPP_URL ? 'noopener noreferrer' : undefined;
  return <Component href={href} onClick={onClick} target={target} rel={rel} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-11">
      {children}
      {icon && <span className="ml-1" data-id="element-12">{icon}</span>}
    </Component>;
}